import React, { useState } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { toggleDialog as toggleLogoDialog } from 'actions/logoManagementAndBranding'
import Button from 'components/theme/Button'
import { Add, Help, Settings, Person } from '@material-ui/icons'
import { Avatar, withStyles } from '@material-ui/core'
import { AccountMinusOutline, AccountPlusOutline } from 'mdi-material-ui'
import Link from 'utils/Link'
import { userSignOut } from 'actions/auth'
import { Auth } from 'aws-amplify'
import { toggleDialog as toggleUserDialog, selectUser } from 'actions/users'

const isTokenExpired = profile => {
  if (!profile.idToken) return { expired: true, reason: 'No idToken' }

  const now = Math.floor(Date.now() / 1000)
  let payload
  try {
    payload = JSON.parse(atob(profile.idToken.split('.')[1]))
  } catch (error) {
    return { expired: true, reason: 'Invalid token format' }
  }

  const expiration = payload.exp
  const isExpired = now >= expiration

  return {
    expired: isExpired,
    expiration,
    now,
    timeLeft: expiration - now,
  }
}

const refreshToken = async profile => {
  try {
    const currentUser = await Auth.currentAuthenticatedUser()
    const currentSession = await Auth.currentSession()
    await new Promise((resolve, reject) => {
      currentUser.refreshSession(
        currentSession.refreshToken,
        (err, session) => {
          if (err) {
            reject(err)
          } else {
            resolve(session)
          }
        },
      )
    })
    return true
  } catch (error) {
    console.error('Error refreshing token:', error)
    return false
  }
}

const urlParams = new URLSearchParams(window.location.search)
const jwtToken = urlParams.get('jwtToken')

// function iOS() {
//   return (
//     [
//       'iPad Simulator',
//       'iPhone Simulator',
//       'iPod Simulator',
//       'iPad',
//       'iPhone',
//       'iPod',
//     ].includes(navigator?.platform) ||
//     // iPad on iOS 13 detection
//     (navigator?.userAgent?.includes('Mac') && 'ontouchend' in document)
//   )
// }

const styles = theme => ({
  profile: {
    cursor: 'pointer',
    padding: 15,
    textAlign: 'left',
    position: 'relative',
    '&:hover': {
      backgroundColor: '#8080804a',
    },
  },
  link: {
    cursor: 'pointer',
    color: '#000',
    '&:hover': {
      textDecoration: 'underline',
    },
  },
  avatarRoot: {
    width: 50,
    height: 50,
  },
})

const Profile = ({
  company_logo_url_color,
  business_name,
  history,
  openProfileDialog,
  toggleLogoDialog,
  profiles,
  cognitoUsername,
  given_name,
  family_name,
  default_email_from,
  classes,
  userSignOut,
  myEmailAddress,
  toggleUserDialog,
  selectUser,
  vr_account_id,
  accountsettingsAllowed,
  vr_role,
}) => {
  const [username, setUsername] = useState('')
  const [password, setPassword] = useState('')
  const [loginDisplayed, setLoginDisplayed] = useState(false)

  if (!Object.keys(profiles || {}).length) {
    if (window?.ReactNativeWebView?.postMessage) {
      window.ReactNativeWebView.postMessage('getProfiles')
    }
  }

  const devOrProd =
    window?.location?.href?.slice?.(0, 29) === 'https://console.vastreach.com'
      ? 'Prod'
      : 'Dev'

  const devOrProdKey =
    window?.location?.href?.slice?.(0, 29) === 'https://console.vastreach.com'
      ? '2j1q69p1gd5mk75aape1ck8arg'
      : '68t3ue2bjp3tdl6177i68nrpf4'

  const vastReachProfilesByUsernameString = jwtToken
    ? null
    : window?.localStorage?.getItem(`vastReachProfilesByUsername${devOrProd}`)

  const vastReachProfilesByUsername = jwtToken
    ? {}
    : JSON.parse(vastReachProfilesByUsernameString)

  const profilesObj = Object.keys(profiles || {}).length
    ? profiles
    : vastReachProfilesByUsername

  delete profilesObj[cognitoUsername]
  // profilesObj[cognitoUsername] = undefined

  const profileSwitcherAllowed = () => {
    if (jwtToken) {
      return false
    }
    return true
  }

  const handleLogin = () => {
    if (jwtToken) {
      return window?.ReactNativeWebView?.postMessage?.(
        JSON.stringify({
          newProfile: { username, password },
        }),
      )
    }
    return Auth.signIn(username, password)
      .then(() => {
        setLoginDisplayed(false)
        window.location.reload()
      })
      .catch(err => {
        // Handle login error, e.g., show an error message
        console.error('Login failed:', err)
      })
  }

  return (
    <div style={{ textAlign: 'center', position: 'relative' }}>
      <div style={{ backgroundColor: '#006fd9', padding: '14px 20px' }}>
        {company_logo_url_color ? (
          <img
            src={company_logo_url_color}
            alt="Your logo"
            style={{
              maxHeight: 56,
              maxWidth: '100%',
              // backgroundColor: '#006fd9',
            }}
          />
        ) : business_name ? (
          <Avatar
            style={{
              display: 'inline-block',
              height: 50,
              width: 50,
              backgroundColor: '#014c94',
              color: '#fff',
              borderRadius: '50%',
              fontSize: 16,
              padding: '15px 0px ',
            }}
          >
            {business_name
              ?.split?.(' ')
              ?.slice?.(0, 3)
              ?.map?.(word => word?.slice?.(0, 1))
              ?.join('')
              ?.toUpperCase?.() || ''}
          </Avatar>
        ) : null}
        {business_name && (
          <div
            variant="h6"
            color="inherit"
            style={{ color: '#fff', fontSize: 24, marginTop: 5 }}
          >
            {business_name}
          </div>
        )}
        {!company_logo_url_color && !business_name && (
          <Button
            variant="contained"
            color="secondary"
            onClick={() => {
              openProfileDialog(false)
              history.push('/accountsettings')
              toggleLogoDialog(true)
            }}
          >
            {'Add logo & business name'}
          </Button>
        )}
      </div>
      <div style={{ color: 'gray', marginTop: 5 }}>signed in as</div>
      <div
        style={{
          textOverflow: 'ellipsis',
          overflow: 'hidden',
          whiteSpace: 'nowrap',
        }}
      >
        <strong>{`${given_name} ${family_name}`}</strong> | {cognitoUsername}
      </div>
      {(default_email_from || myEmailAddress) && (
        <div
          style={{
            textOverflow: 'ellipsis',
            overflow: 'hidden',
            whiteSpace: 'nowrap',
          }}
        >
          {myEmailAddress || default_email_from}
        </div>
      )}
      <div>
        <Button
          onClick={() => {
            openProfileDialog(false)
            history.push('/accountsettings')
            toggleUserDialog(true)
            selectUser(cognitoUsername)
          }}
          style={{ marginTop: 5 }}
        >
          <Person style={{ marginRight: 5 }} />
          View my profile
        </Button>
      </div>
      {accountsettingsAllowed === false ? null : (
        <Button
          onClick={() => {
            openProfileDialog(false)
            history.push('/accountsettings')
          }}
          style={{ marginTop: 5 }}
        >
          <Settings style={{ marginRight: 5 }} />
          Account settings
        </Button>
      )}
      {profileSwitcherAllowed() && (
        <>
          <div
            style={{
              height: 1,
              backgroundColor: 'gray',
              marginTop: 10,
              marginBottom: 10,
            }}
          />
          {Object.values(profilesObj).length ? (
            <div
              style={{
                textAlign: 'left',
                paddingLeft: 10,
                paddingBottom: 5,
                fontWeight: 'bold',
                borderBottom: '1px solid #f0f0f0',
              }}
            >
              Switch Accounts
            </div>
          ) : null}
          <div style={{ maxHeight: 240, overflowY: 'auto' }}>
            {Object.values(profilesObj).map(profileObj => (
              <div
                onClick={async () => {
                  if (jwtToken) {
                    return window?.ReactNativeWebView?.postMessage?.(
                      JSON.stringify({
                        switchProfile: { username: profileObj?.username },
                      }),
                    )
                  }

                  const tokenStatus = isTokenExpired(profileObj)

                  if (tokenStatus.expired) {
                    console.log(`Token expired. Attempting refresh.`)
                    const refreshed = await refreshToken(profileObj)

                    if (refreshed) {
                      console.log('Token refreshed successfully')
                      // Proceed with profile switch

                      if (window?.localStorage?.setItem) {
                        window.localStorage.setItem(
                          `CognitoIdentityServiceProvider.${devOrProdKey}.LastAuthUser`,
                          profileObj?.username,
                        )
                        window.location.reload()
                      }
                    } else {
                      console.log('Token refresh failed. Showing login form.')
                      setLoginDisplayed(true)
                      setUsername(profileObj.username)
                    }
                  } else {
                    console.log(
                      `Token valid. Time left: ${tokenStatus.timeLeft} seconds`,
                    )
                    // Token is not expired, proceed with profile switch
                    if (window?.localStorage?.setItem) {
                      window.localStorage.setItem(
                        `CognitoIdentityServiceProvider.${devOrProdKey}.LastAuthUser`,
                        profileObj?.username,
                      )
                      window.location.reload()
                    }
                  }
                }}
                className={classes.profile}
              >
                <Avatar
                  classes={{ root: classes.avatarRoot }}
                  style={{ backgroundColor: '#014c94' }}
                >
                  {profileObj?.business_name ? (
                    profileObj.business_name
                      ?.split?.(' ')
                      ?.slice?.(0, 3)
                      ?.map?.(word => word?.slice?.(0, 1))
                      ?.join('')
                      ?.toUpperCase?.()
                  ) : (
                    <Person />
                  )}
                </Avatar>
                <div
                  style={{
                    position: 'absolute',
                    left: 80,
                    top: '50%',
                    transform: 'translate(0, -50%)',
                    maxWidth: 'calc(100% - 80px)',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    whiteSpace: 'nowrap',
                  }}
                >
                  {profileObj?.business_name ? (
                    <>
                      <strong>{profileObj?.business_name}</strong>
                      <br />
                      <span>{profileObj?.username}</span>
                    </>
                  ) : (
                    profileObj?.username
                  )}
                </div>
              </div>
            ))}
          </div>
          {/* ; */}
          <div style={{ paddingTop: 13, borderTop: '1px solid #f0f0f0' }}>
            <Button
              disabled={loginDisplayed}
              onClick={() => setLoginDisplayed(true)}
            >
              <Add style={{ marginRight: 5 }} />
              Add another account
            </Button>
          </div>
          {loginDisplayed && (
            <>
              <input
                autoCapitalize="off"
                style={{ marginBottom: 5, marginTop: 5 }}
                value={username}
                placeholder="Username"
                onChange={e => setUsername(e?.target?.value)}
              />
              <br />
              <input
                style={{ marginBottom: 5 }}
                value={password}
                type="password"
                placeholder="Password"
                onChange={e => setPassword(e?.target?.value)}
                onKeyDown={e => {
                  if (e?.keyCode === 13) {
                    handleLogin()
                  }
                }}
              />
              <br />
              <Button
                onClick={handleLogin}
                variant="contained"
                color="secondary"
              >
                Sign in
              </Button>
            </>
          )}
        </>
      )}
      <div
        style={{
          height: 1,
          backgroundColor: 'gray',
          marginTop: 10,
          marginBottom: 10,
        }}
      />
      <Button
        onClick={() =>
          jwtToken
            ? window?.ReactNativeWebView?.postMessage?.('signout')
            : userSignOut()
        }
        variant="outlined"
      >
        <AccountMinusOutline style={{ marginRight: 5 }} />
        Sign out
      </Button>
      {jwtToken && (
        <Button
          style={{ marginLeft: 5 }}
          onClick={() =>
            jwtToken
              ? window?.ReactNativeWebView?.postMessage?.('switchprofile')
              : userSignOut()
          }
          variant="outlined"
        >
          <AccountPlusOutline style={{ marginRight: 5 }} />
          Switch/Add Profile
        </Button>
      )}
      <div style={{ marginTop: 10 }}>
        <Button
          target="_blank"
          onClick={() => {
            openProfileDialog(false)
            if (window?.ReactNativeWebView?.postMessage) {
              window.ReactNativeWebView.postMessage('https://vastreach.com/faq')
            } else {
              return window
                .open?.('https://vastreach.com/faq', '_blank')
                ?.focus()
            }
          }}
        >
          <Help style={{ marginRight: 5 }} />
          Get Help
        </Button>
      </div>
      <div
        style={{
          height: 1,
          backgroundColor: 'gray',
          marginTop: 10,
          marginBottom: 10,
        }}
      />
      <div>
        <Link
          style={{ textDecoration: 'none' }}
          target="_blank"
          href="https://vastreach.com/PrivacyPolicy"
        >
          <span className={classes.link}>Privacy policy</span>
        </Link>
        {' | '}
        <Link
          style={{ textDecoration: 'none' }}
          target="_blank"
          href="https://vastreach.com/TermsOfService"
        >
          <span className={classes.link}>Terms of service</span>
        </Link>
      </div>
      {vr_role === 'acctowner' && (
        <div style={{ marginTop: 16 }}>
          <Link
            style={{ textDecoration: 'none' }}
            target="_blank"
            href="https://leads.vastreach.com/custom/f97a5dba-fc1f-48b7-833b-cb14b1f874aa"
          >
            <span style={{ color: '#a6a6a6' }} className={classes.link}>
              Delete account
            </span>
          </Link>
        </div>
      )}
    </div>
  )
}

export default connect(
  state => {
    const cognitoUsername =
      state?.auth?.session?.idToken?.payload?.['cognito:username']
    const vr_account_id =
      state.auth?.session?.idToken?.payload?.['custom:vr_account_id']

    return {
      company_logo_url_color:
        state.data?.['account/preference']?.preferences?.company_logo_url_color,
      business_name: state.data?.account?.business_name,
      profiles: state.data?.profiles || {},
      cognitoUsername,
      given_name: state.auth?.session?.idToken?.payload?.given_name,
      family_name: state.auth?.session?.idToken?.payload?.family_name,
      default_email_from:
        state.data?.['account/preference']?.preferences?.default_email_from,
      myEmailAddress: state.data?.['account/user']?.[cognitoUsername]?.email,
      vr_account_id,
      accountsettingsAllowed:
        state.data?.screenpermissions?.[
          `screenpermissions-${cognitoUsername}-${vr_account_id}`
        ]?.permissions?.accountsettings,
      vr_role: state.auth?.session?.idToken?.payload?.['custom:vr_role'],
    }
  },
  dispatch =>
    bindActionCreators(
      { toggleLogoDialog, userSignOut, toggleUserDialog, selectUser },
      dispatch,
    ),
)(withStyles(styles)(Profile))
